<template>
  <div id="flip">
    <h1 class="text-center">BlueChipCar Flip Model</h1>
    <h3 class="text-center pb-10">FLIP participants invest directly in an individual collector car alongside industry professionals and veteran collectors. Investors share the profits or losses after the car is sold at an open market auction.</h3>
    <v-tabs class="d-none d-sm-block"
      v-model="tab"
      background-color="blue lighten-5"
      color="blue"
      grow
    >
      <v-tab href="#funding"><v-icon class="pr-2">mdi-finance</v-icon> Funding / WPO</v-tab>
      <v-tab href="#auction"><v-icon class="pr-2">mdi-clock-time-eight-outline</v-icon>Funded / Awaiting Sale</v-tab>
      <v-tab href="#complete"><v-icon class="pr-2">mdi-check-decagram-outline</v-icon> Complete</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item value="funding">
        <ActiveFlipGrid></ActiveFlipGrid>
      </v-tab-item>
      <v-tab-item value="auction">
        <ActiveFlipGridAuction></ActiveFlipGridAuction>
        <ActiveFlipGridSoldOut></ActiveFlipGridSoldOut>
      </v-tab-item>
      <v-tab-item value="complete">
        <CompletedFlipGrid></CompletedFlipGrid>
      </v-tab-item>
    </v-tabs-items>

    <v-tabs
      v-model="tab"
      background-color="blue lighten-5"
      color="blue"
      grow
      v-if="$vuetify.breakpoint.mdAndUp"
    >
      <v-tab href="#funding"><v-icon class="pr-2">mdi-finance</v-icon> Funding / WPO</v-tab>
      <v-tab href="#auction"><v-icon class="pr-2">mdi-clock-time-eight-outline</v-icon>Funded / Awaiting Sale</v-tab>
      <v-tab href="#complete"><v-icon class="pr-2">mdi-check-decagram-outline</v-icon> Complete</v-tab>
    </v-tabs>
    <v-bottom-navigation
    background-color="secondary"
    height="90"
    v-if="$vuetify.breakpoint.smAndDown"
    dark
    grow
    fixed
  >
    <v-btn class="text-center"
      to="/flip?tab=funding"
      :disabled="tab == 'funding'"
    >
      <span>Funding /<br />WPO</span>
      <v-icon>mdi-finance</v-icon>
    </v-btn>
    <v-btn class="text-center"
      to="/flip?tab=auction"
      :disabled="tab == 'auction'"
    >
      <span>Funded /<br />Awaiting Sale</span>
      <v-icon>mdi-clock-time-eight-outline</v-icon>
    </v-btn>
    <v-btn class="text-center"
      to="/flip?tab=complete"
      :disabled="tab == 'complete'"
    >
      <span>Complete</span>
      <v-icon>mdi-check-decagram-outline</v-icon>
    </v-btn>
  </v-bottom-navigation>
  </div>

</template>

<script>
  import ActiveFlipGrid from '../components/ActiveFlipGrid.vue'
  import CompletedFlipGrid from '../components/CompletedFlipGrid.vue'
  import ActiveFlipGridAuction from '../components/ActiveFlipGridAuction.vue'
  import ActiveFlipGridSoldOut from '../components/ActiveFlipGridSoldOut.vue'

  export default {
    name: 'Flip',

    components: {
      ActiveFlipGrid,
      CompletedFlipGrid,
      ActiveFlipGridAuction,
      ActiveFlipGridSoldOut
    },

    computed: {
      /*
      * Store the current tab in the URL so we can activate via menu
      * item instead of tab on mobile.
      *
      * URL will include the current tab as a query parameter on first visit.
      * It will also update this parameter automatically when tab is switched.
      *
      */
      tab: {
        set (tab) {
          this.$router.replace({ query: { ...this.$route.query, tab } })
        },
        get () {
          //console.log(this.$route.query.tab)
          return this.$route.query.tab
        }
      }
    },
  }
</script>
